



































import { Component, Vue, Ref } from 'vue-property-decorator';
import LabelModal from './components/labelModal.vue';
import { LabelModule } from '@/store/modules/label';

type ILabelClass = ILabel.IModel.ILabelClass;

const columns = [
  {
    slots: { title: 'labelTit' },
    dataIndex: 'color',
    scopedSlots: { customRender: 'color'},
    width: '15%',
  },
  {
    slots: { title: 'commentTit' },
    dataIndex: 'comment',
    // scopedSlots: { customRender: 'comment'},
    width: '30%',
  },
  {
    slots: { title: 'createdNameTit' },
    dataIndex: 'createdName',
    scopedSlots: { customRender: 'createdName'},
    width: '15%',
    align: 'center',
  },
  {
    slots: { title: 'isPublicTit' },
    dataIndex: 'isPubilc',
    scopedSlots: { customRender: 'isPubilc'},
    width: '5%',
    align: 'center',
  },
  {
    slots: { title: 'isActiveTit' },
    dataIndex: 'active',
    scopedSlots: { customRender: 'isActive'},
    width: '5%',
    align: 'center',
  },
  {
    slots: { title: 'actionTit' },
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: '10%',
    align: 'center',
  },
];

@Component({
  name: 'Label',
  components: {
    LabelModal,
  },
})
export default class Label extends Vue {
  @Ref() private readonly labelModal!: LabelModal;
  private columns = columns;
  private pagination = {
    pageSize: 10,
    hideOnSinglePage: true,
  };
  get labelList() {
    return LabelModule.labelList;
  }
  get labelsData() {
    return this.labelList.data;
  }
  private spinning = false;
  private created() {
    this.refreshLabels();
  }
  private refreshLabels() {
    this.spinning = true;
    this.labelList.requestLabels().then((res) => {
      this.spinning = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.spinning = false;
    });
  }
  private createLabel() {
    LabelModule.ToggleLabelModalVisible();
    LabelModule.InitLabelModal();
  }
  private editLabel(label: ILabelClass) {
    LabelModule.ToggleLabelModalVisible();
    LabelModule.InitLabelModal(label);
  }
  private deleteLabel(labelId: string) {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {operation: this.$t('form.delete')}).toString(),
      onOk: () => {
        this.submitDelete(labelId);
      },
    });
  }
  private submitDelete(labelId: string) {
   this.labelList.requestDeleteLabel(labelId).then((res) => {
      this.$message.success(res);
      LabelModule.GetLabels(true);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
}
